import {CloseOutlined, DownloadOutlined} from "@ant-design/icons";
import React from "react";
import {useCurrentLightboxAttributes} from "../hooks/useCurrentLightboxAttributes";
import {useSelector} from "react-redux";
import classNames from "classnames";

export function Topbar({
    onClose,
}) {
    const currentIndex = useSelector(state => state.Lightbox.currentIndex);
    const fileCount = useSelector(state => state.Lightbox.files.length);
    const lightboxType = useSelector(state => state.Lightbox.lightboxType);

    const {
        contentFileName,
        contentSrc,
        itemShowDownload,
    } = useCurrentLightboxAttributes(lightboxType);

    const getDownloadBtn = () => {
        if (itemShowDownload) {
            // needs to be configured with yarn build + apache
            const href = `/redirect?to=${decodeURIComponent(contentSrc)}`;
            return (
                <span className="topbar__download-icon">
                    <a href={href} download={contentFileName}>
                        <DownloadOutlined className="lightbox-btn download" />
                    </a>
                </span>
            );
        }
        return null;
    };

    const fileCountDom = () => {
        if (fileCount) {
            return (
                <span className="topbar__counter">
                    {currentIndex + 1}
                &nbsp;/&nbsp;
                    {fileCount}
                </span>
            );
        }
        return null;
    };
    return (
        <div className={
            classNames(
                'lightbox-modal-topbar',
                {
                    'counter-hidden': !fileCount,
                },
            )
        }
        >
            {fileCountDom()}
            <span className="topbar_btn-group">
                {getDownloadBtn()}
                <span className="topbar__close-icon" onClick={e => onClose(e, true)}>
                    <CloseOutlined className="lightbox-btn close" />
                </span>
            </span>
        </div>
    );
}
